import {Component, Input, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'app-tool-setting',
    templateUrl: './tool-setting.component.html',
    styleUrls: ['./tool-setting.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class ToolSettingComponent {
    @Input()
    public label!: string;
}
